import { Component, Input, OnInit } from '@angular/core';
import { VwPrpoInfor } from 'src/app/sdk/models';
import { PrMasterControllerService, VwPrpoInforControllerService } from 'src/app/sdk/services';
import { PR_PO_CONTENT } from './constant/pr-po-info';

@Component({
  selector: 'app-prpo-info',
  templateUrl: './prpo-info.component.html',
  styleUrls: ['./prpo-info.component.scss']
})
export class PrpoInfoComponent implements OnInit {
  @Input() formid: string;
  @Input() electromechanical: boolean = false;
  @Input() civilEngineering: boolean = false;

  listOption = [...PR_PO_CONTENT];
  listOfData: VwPrpoInfor[] = [];
  constructor(
    private prMasterControllerService: PrMasterControllerService,
    private vwPrpoInforControllerService: VwPrpoInforControllerService,
  ) { }

  async ngOnInit(): Promise<void> {
    await this.getInitPRPOInfo();
  }

  async getInitPRPOInfo() {
    this.listOfData = [];
    let temp: VwPrpoInfor[] = [];
    // 获取PR信息
    await this.prMasterControllerService.getPrInfo({ formId: this.formid }).toPromise().then(async prRes => {
      if (Object.keys(prRes).length > 0) {
        // 获取PO信息
        await this.vwPrpoInforControllerService.find(
          {
            filter: JSON.stringify(
              {
                "where":
                {
                  "recharge": this.formid
                }
              }
            )
          }
        ).toPromise().then(poRes => {
          poRes.forEach(item=>{
            temp.push(
              {
                itemdesc: item['itemdesc'],
                purno: item['purno'],
                itemno: item['itemno'],
                pono: item['pono'],
                poln: item['poln'],
                outsource: item['outsource'],
                cusr: item['cusr'],
                amnt: item['amnt'],
                ddat: item['ddat'],
                poAttachment: item['poAttachment'],
              }
            );
          }) 
        });
      }
      this.listOfData = temp;
    });
  }
}
